import { Routes } from '@angular/router';
import { AuthComponent } from './features/auth/auth.component';
import { MainComponent } from './features/main/main.component';
import { LoginComponent } from './features/auth/login/login.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: 'login', component: LoginComponent }
    ]
  },
  {
    path: 'app',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/main/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'monitoring',
        loadComponent: () =>
          import('./features/main/monitoring/monitoring.component').then((m) => m.MonitoringComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/main/users/list-users/list-users.component').then((m) => m.ListUsersComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'users/:id',
        loadComponent: () =>
          import('./features/main/users/new-user/new-user.component').then((m) => m.NewUserComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'profiles',
        loadComponent: () =>
          import('./features/main/profiles/profiles.component').then((m) => m.ProfilesComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'measurement',
        loadComponent: () =>
          import('./features/main/record-measurement/list-record-measurement/list-record-measurement.component').then((m) => m.ListRecordMeasurementComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'measurement/:id',
        loadComponent: () =>
          import('./features/main/record-measurement/record-measurement.component').then((m) => m.RecordMeasurementComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'patients',
        loadComponent: () =>
          import('./features/main/patients/list-patients/list-patients.component').then((m) => m.ListPatientsComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'patients/:id',
        loadComponent: () =>
          import('./features/main/patients/patients/patients.component').then((m) => m.PatientsComponent),
        canActivate: [AuthGuard]
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    ]
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

